import { useShippingProviderCountries } from 'features/shipping-provider/hooks/useShippingProviderCountries';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderMappedRatesList } from './ProviderMappedRatesList';

export const MarketDrivenShippingMigratedModalContent: React.FC = () => {
    const { t } = useTranslation();

    const { providerToCountry } = useShippingProviderCountries();

    const activeProviderNames = useMemo(
        () => [...new Set(Object.values(providerToCountry ?? {}).flat())],
        [providerToCountry]
    );

    return (
        <div className="flex flex-col gap-4">
            <s-text>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.INTRO')}</s-text>
            <div className="flex flex-col gap-2">
                <s-heading>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.WHATS_NEW_HEADING')}</s-heading>
                <ul className="flex flex-col gap-1 pl-5 list-disc">
                    <li>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.BULLET_1')}</li>
                    <li>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.BULLET_2')}</li>
                </ul>
            </div>
            <div className="flex flex-col gap-2">
                <s-heading>{t('MARKET_DRIVEN_SHIPPING_MIGRATED_BANNER.MODAL.MAPPED_RATES_HEADING')}</s-heading>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    {activeProviderNames.map((provider) => (
                        <ProviderMappedRatesList key={provider} provider={provider} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MarketDrivenShippingMigratedModalContent;
